/** @jsx jsx */

import { PropsWithChildren } from 'react';

import { Margin, Surface, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import { DEV_BREAK_POINTS } from 'app/developer-v3/constants';

const Styles = {
  content: css`
    align-items: center;
    display: flex;
    padding: 15px;
    justify-content: space-between;

    @media screen and (max-width: ${DEV_BREAK_POINTS.default}) {
      flex-direction: column;
    }
  `,
  main: (hasAside?: boolean) => [
    css`
      font-size: 15px;
      font-weight: 400;
      line-height: 20px;
      width: 100%;
    `,
    hasAside &&
      css`
        width: 60%;

        @media screen and (max-width: ${DEV_BREAK_POINTS.default}) {
          width: 100%;
        }
      `,
  ],
  aside: css`
    width: 35%;
    column-gap: 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;

    @media screen and (max-width: ${DEV_BREAK_POINTS.default}) {
      justify-content: flex-start;
      width: 100%;
      margin-top: 15px;
    }
  `,
};

const HeaderCTA = ({ children }: PropsWithChildren<{}>) => {
  return (
    <Text color="gray80" tag="h3" type="paragraph3Bold">
      {children}
    </Text>
  );
};

const BodyCTA = ({ children }: PropsWithChildren<{}>) => {
  return <Margin margin="15px 0px 0px 0px">{children}</Margin>;
};

const Main = ({
  children,
  hasAside,
}: PropsWithChildren<{ hasAside?: boolean }>) => {
  return <div css={Styles.main(hasAside)}>{children}</div>;
};

const Aside = ({ children }: PropsWithChildren<{}>) => {
  return <div css={Styles.aside}>{children}</div>;
};

const CTA = (props: PropsWithChildren<{}>) => {
  const { children } = props;
  return (
    <Margin margin="15px 0px 0px 0px">
      <Surface borderColor="gray40">
        <div css={Styles.content}>{children}</div>
      </Surface>
    </Margin>
  );
};

CTA.Header = HeaderCTA;
CTA.Body = BodyCTA;
CTA.Main = Main;
CTA.Aside = Aside;

export default CTA;
